import { defineMessages } from "react-intl";
import { RevenueShareOfferingStatus } from "../../contract/pam.js";
const localizedRevenueShareOfferingStatus = defineMessages({
  [RevenueShareOfferingStatus.Active]: {
    id: "localizedRevenueShareOfferingStatusActive",
    defaultMessage: "Active"
  },
  [RevenueShareOfferingStatus.Inactive]: {
    id: "localizedRevenueShareOfferingStatusInactive",
    defaultMessage: "Inactive"
  }
});
export {
  localizedRevenueShareOfferingStatus
};
//# sourceMappingURL=revenueShareOfferingStatus.js.map
